import { useCallback } from "react";
import { ShareActions } from "@/components/ShareActions";
import { SquabInvite } from "@/components/SquabInvite";
import { resultText, resultsCard, resultsUrl } from "@/lib/resultSharing";
import { prepareFacebookCard } from "@/lib/publicSharing";

export function PuzzleResultsSharing({ result, playId }) {
  const createCard = useCallback(() => resultsCard(result), [result]);
  const facebookCard = useCallback(blob => prepareFacebookCard(blob, { play_id: playId }), [playId]);
  return <ShareActions text={resultText(result)} url={resultsUrl(result.puzzleId)} createCard={createCard} facebookCard={facebookCard}>
    <SquabInvite playId={playId} className="border border-primary px-4 py-3 text-primary font-mono-caps text-xs disabled:opacity-50" />
  </ShareActions>;
}
